import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import * as moment from "moment"
import { isEmpty, size } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {showSuccessToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Button,
  Card,
  CardBody,
  Col,
  CardTitle,
  Container,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import RightDrawer from "../../components/Common/RightDrawer"
//redux
import { useSelector, useDispatch } from "react-redux"
import SweetAlert from "react-bootstrap-sweetalert"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import ExcelDownload from "components/Common/ExcelDownload"
import ReportDayPicker from "components/Common/ReportDayPicker"
import { showNoDataIndication } from "helpers/function_helper"

import { getReport } from "helpers/backend_helper"
import Loader from "components/Common/Loader"

const SalesReport = props => {
  const limit = 100;
  useEffect(() => {
    
    getSalesReport({
      startDate : moment(new Date()).format("yyyy-MM-DD"),
      endDate : moment(new Date()).format("yyyy-MM-DD"),
      //limit : limit,
      //lastId : 0
    })
  }, []);

  const getSalesReport = (input) => {
    setIsLoading(true)
    setSelectedDate({
      startDate:input.startDate,
      endDate: input.endDate,
    })
    getReport(input,'salesreport').then(resp => {
      setSalesRecords(resp)
      setIsLoading(false)
      if(resp.length > 0){
        let header = []
        let rows = []
        resp.forEach((sales,index) =>{
          let columns = []
          currentReportColumns.forEach((col) => {
            if(currentColumns.includes(col.dataField)){
              if(index == 0){
                /*
                header.push(
                  {
                    value: String(col.text),
                    style: { font: { sz: "24", bold: true } },
                  }
                )
                */
                header.push(String(col.text))
              }
              columns.push({
                value: String(sales[col.dataField]),
                style: { font: { sz: "14", bold: false } } 
              })
              //columns.push(String(sales[col.dataField]))
            }
          })
          rows.push(columns)
        })

        //console.log('header:'+JSON.stringify(header))
        //console.log('rows:'+JSON.stringify(rows))
        let tempData = []
        //console.log('excelData[0]:'+JSON.stringify(excelData[0]))
        //tempData.push(excelData[0])
        tempData.push({
          columns: header,
          data: rows
        })
        setExcelData(tempData)
      }
    })
  }
  
  const [isLoading, setIsLoading] = useState(false)
  const [salesRecords, setSalesRecords] = useState([])
  const [excelData, setExcelData] = useState([{
    columns: [],
    data: []
  },{
    columns: [{
      value: '',
      style: { font: { sz: "24", bold: true } },
    }],
    data: [{
      value: '',
      style: { font: { sz: "20", bold: true } },
    }]
  }])

  const [selectedDate, setSelectedDate] = useState({
    startDate : moment(new Date()).format("yyyy-MM-DD"),
    endDate : moment(new Date()).format("yyyy-MM-DD"),
  })

  const handleValidDate = date => {
    return moment(new Date(date)).format("DD MMM Y")
  }

  const onConfirmSelectedDates = (dates) => {
    setSalesRecords([])
    getSalesReport({
      startDate : dates.startDate,
      endDate : dates.endDate,
    })
  }

  const requiredColumns = ["invoicedate","invoiceno","name","address","statename","statecode","productname","hsncode","productqty","unit","gstpercentage","productnetwithouttax","productcgst","productsgst","productigst","producttotal"]

  const reportColumns =  [
    {
      dataField: "id",
      isDummyField: true,
      text: "#",
      hidden: true
    },
    {
      dataField: "invoicedate",
      text: "Invoice Date",
      sort: true,
      formatter: (cellContent, row) => handleValidDate(cellContent),
    },
    {
      dataField: "invoiceno",
      text: "Invoice #",
      sort: true,
    },
    {
      dataField: "name",
      text: "Customer",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "statename",
      text: "State",
      sort: true,
    },
    {
      dataField: "statecode",
      text: "State Code",
      sort: true,
    },
    {
      dataField: "productcode",
      text: "Pdt Code",
      sort: true,
    },
    {
      dataField: "productname",
      text: "Pdt Name",
      sort: true,
    },
    {
      dataField: "hsncode",
      text: "HSN",
      sort: true,
    },
    {
      dataField: "productqty",
      text: "Qty",
      sort: true,
    },
    {
      dataField: "unit",
      text: "Unit",
      sort: true,
    },
    {
      dataField: "gstpercentage",
      text: "Tax %",
      sort: true,
    },
    {
      dataField: "productnetwithouttax",
      text: "Amount",
      sort: true,
    },
    {
      dataField: "productcgst",
      text: "CGST",
      sort: true,
    },
    {
      dataField: "productsgst",
      text: "SGST",
      sort: true,
    },
    {
      dataField: "productigst",
      text: "IGST",
      sort: true,
    },
    {
      dataField: "producttotal",
      text: "Total",
      sort: true,
    }
    
  ]

  const [currentColumns, setCurrentColumns] = useState(requiredColumns)
  const [currentReportColumns, setCurrentReportColumns] = useState(reportColumns)

  const multiDataSet = [
    {
        columns: ["Name", "Salary", "Sex"],
        data: [
            ["Johnson", 30000, "Male"],
            ["Monika", 355000, "Female"],
            ["Konstantina", 20000, "Female"],
            ["John", 250000, "Male"],
            ["Josef", 450500, "Male"],
        ]
    },
    {
        xSteps: 1, // Will start putting cell with 1 empty cell on left most
        ySteps: 5, //will put space of 5 rows,
        columns: ["Name", "Department"],
        data: [
            ["Johnson", "Finance"],
            ["Monika", "IT"],
            ["Konstantina", "IT Billing"],
            ["John", "HR"],
            ["Josef", "Testing"],
        ]
    }
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Sales Records | Flamingo</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Reports" breadcrumbItem="Sales Records" />
          
          <Row>
            <Col xs="12">
              <Card>
                <CardTitle className="mt-0">
                  <Row className="mt-2">
                    <Col xs="3">
                      
                    </Col>
                    <Col xs="4" className="text-center align-middle align-self-center">
                      Sales Records
                    </Col>
                    <Col xs="4" className="text-end d-inline-block">
                      <ReportDayPicker 
                      onConfirmSelectedDates={onConfirmSelectedDates}
                      loadInProgress={isLoading}
                      /> 
                    </Col>
                    <Col xs="1" className="align-middle align-self-center">
                      <ExcelDownload filename={"Sales Records - "+selectedDate.startDate +"-"+selectedDate.endDate} sheetname="Sales" dataSet={excelData}/>
                    </Col>
                  </Row>
                </CardTitle>
                <CardBody style={{minHeight:550}}>
                  <ToolkitProvider
                    keyField="id"
                    data={salesRecords || []}
                    columns={reportColumns}
                    bootstrap4
                  >
                    {toolkitProps => (
                      <React.Fragment>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                responsive
                                remote
                                bordered={false}
                                striped={false}
                                classes={
                                  "table align-middle table-nowrap table-hover"
                                }
                                {...toolkitProps.baseProps}
                                noDataIndication={showNoDataIndication(isLoading)}
                              />
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

SalesReport.propTypes = {
}

export default withRouter(SalesReport)
